// export * from "./design";
export * from "./studies";
export * from "./run";
export * from "./auth";
export * from "./tags";
export * from "./home";
export * from "./assets";
export * from "./debug";

// catch-all
export const FallbackRoute = {
	path: "*",
	redirect: "/home"
};
